import { render, staticRenderFns } from "./LogisticsDetails.vue?vue&type=template&id=a55fc87a&scoped=true&"
import script from "./LogisticsDetails.vue?vue&type=script&lang=js&"
export * from "./LogisticsDetails.vue?vue&type=script&lang=js&"
import style0 from "./LogisticsDetails.vue?vue&type=style&index=0&id=a55fc87a&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a55fc87a",
  null
  
)

export default component.exports